import React from "react";
import Pie from "lib/components/charts/pie.jsx";
import { useMyLearning } from "lib/components/MyLearning/context";

const TotalProgressSection = ({ languageContext, scale = 1 }) => {
  const { totalPercentCompleted } = useMyLearning();

  const pieProgressData = [
    {
      name: languageContext("finished2"),
      color: "#fff",
      y: totalPercentCompleted,
    },
    {
      name: languageContext("remaining"),
      color: "#000",
      y: 100 - totalPercentCompleted,
    },
  ];
  return (
    <div
      className="cardview-filter-section totalprogress"
      style={{ transform: `scale(${scale})` }}
    >
      <Pie
        style={{ height: 110, width: 110 }}
        titleConfig={{ color: "#0b537e", titleFontSize: "22px", y: 25 }}
        value={`${totalPercentCompleted}%`}
        data={pieProgressData}
        legendConfig={{ enabled: false }}
        margin="0"
      />
    </div>
  );
};

export default TotalProgressSection;
